export const TABS = ['Personal', 'Housing', 'Income'];
